import styled from 'styled-components'
import { OrderSummary } from '../../receipt/OrderSummary'
import { ActionButton, DeliveryAddressWrapper, DeliveryPaymentWrapper, Item, OrderSummaryTitle, TotalsWrapper } from '../../receipt/OrderSummary/styles'
import {
  Button as DefaultButton
} from '../../components'
export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: column;
  min-width: 100%;
	background: #fff;

  #cart {
    padding: 1.25rem 1rem;

    @media (min-width: 60rem) {
      padding: 2rem 1.5rem;
    }

    #notification {
      display: none;
    }
  }
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: .125rem solid ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textNinethColor) || '#CCC'};
  padding: 1.25rem;
	min-width: calc(100% - 2.5rem);

  @media (min-width: 60rem) {
    padding: 2rem 1.5rem;
    min-width: 100%;
    min-width: 100%;
  }
`

export const StoreOrder = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 100%;
  margin: 0 0 .5rem 0;
`

export const StoreOrderLogo = styled.div`
  border: .125rem solid ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000' };
  padding: 0;
  border-radius: 50%;
  width: 3.5rem;
  height: 3.5rem;
  min-width: 3.5rem;
  min-height: 3.5rem;
  max-width: 3.5rem;
  max-height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1rem 0 0;
  overflow: hidden;

  > img {
    height: auto;
    max-height: unset;
    max-width: 100%;
    min-height: auto;
    min-width: 100%;
    width: 100%;
  }

  svg {
    width: calc(100% - .65rem);
  }
`

export const StoreOrderDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const StoreOrderName = styled.div`
  font-weight: 700;
  font-size: 1rem;
  line-height: 1rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };

  @media (min-width: 60rem) {
    font-size: 1.25rem;
    line-height: 1.688rem;
  }
`

export const StoreOrderDate = styled.div`
  font-weight: 400;
  font-size: .875rem;
  line-height: .875rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000' };

  @media (min-width: 60rem) {
    font-size: 1rem;
    line-height: 1rem;
  }
`

export const StoreOrderModality = styled.div`
  font-weight: 700;
  font-size: 1rem;
  line-height: 1rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  margin: 0 .5rem 0 0;
  padding: 0 .5rem 0 0;
  border-right: 2px solid${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#333'};

  @media (min-width: 60rem) {
    font-size: 1.25rem;
    line-height: 1.25rem; 
  }
`

export const StoreOrderStatus = styled.div`
  font-weight: 700;
  font-size: 1rem;
  line-height: 1rem;

  &.inprogress{
    color: #00892E;
  }

  &.finish{
    color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  }

  @media (min-width: 60rem) {
    font-size: 1.25rem;
    line-height: 1.25rem;
  }
`

export const Help = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 1.25rem 1.25rem 0;
	min-width: 100%;
	box-sizing: border-box;

  @media (min-width: 60rem) {
    padding: 1.25rem 1.5rem 0;  
    width: 100%;
  }
`

export const HelpLabel = styled.label`
  font-weight: 700;
  font-size: .875rem;
  line-height: 1.188.rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  margin: 0 0 1rem 0;
  width: 100%;
`

export const HelpButton = styled.a`
  border: 1px solid ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
  border-radius: 7px;
  font-weight: 400;
  font-size: .75rem;
  line-height: 1.188.rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
  flex: 1 1 calc(50% - .5rem);
  max-width: calc(50% - .5rem);
  height: 2.5rem;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .5rem .25rem;

  &:hover {
    background-color: #f7f7f7;
  }

  &:first-of-type {
    margin: 0 1rem 0 0;
  }

  @media (min-width: 60rem) {
    font-size: .875rem;
  }

  svg {
    margin: 0 0 0 .5rem;

    path {
      fill: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#333'};
      stroke: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#333'};
    }
  }
`

export const CustomOrderSummary = styled(OrderSummary)`
  ${OrderSummaryTitle} {
    display: none;
  }

  ${Item} {
    padding: 0;
    margin: 0;

    &:not(:last-of-type) {
      border-bottom: 1px solid ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textNinethColor) || '#CCC'};
      padding: 0 0 1.5rem 0;
    }

    &:first-of-type {
      padding: 1.5rem 0;

			@media (min-width: 40rem) {
				padding: 1.5rem 1.25rem;
			}
    }
  }

  ${TotalsWrapper} {
    padding: 1.25rem;
  }

  ${ActionButton} {
    margin: 1.25rem !important;
  }

  ${DeliveryAddressWrapper}, ${DeliveryPaymentWrapper} {
    display: flex !important;
    padding: 1.5rem 1.25rem !important;
  }
`
export const MobileHeader = styled.div`
  width: 100%
`
export const H1 = styled.h1`
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  margin: 0;
  padding: 1rem 0;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: bold;
  min-width: 100%;
  text-transform: none;
  text-align: center;
  border-bottom: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textThirdColor) || '#000' } .063rem solid;
  padding-bottom: 1.25rem;

  @media (min-width: 60rem) {
    display: none;
  }
`

export const BackButton = styled.button`
  margin: 0;
  padding: 0;
  background: none;
  border: 0 none;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  font-size: 1rem;
  position: absolute;
  cursor: pointer;
  left: 1.25rem;
  top: 1.25rem;
  z-index: 1;

  @media (min-width: 40rem) {
    display: none;
  }
`

export const DialogWrapper = styled.div`
  display : flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 1rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 1rem;
  bottom: 0 !important;
  top: auto !important;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000' };
`

export const H2 = styled.h2`
  font-size: 1.25rem;
  font-weight: bold;
  color: ${props => props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor };
  text-align: left;
  margin: 0 .8rem;
  padding: 0;
`

export const H3 = styled.h3`
  text-transform: uppercase;
  font-size: 1.5rem;
  font-weight: bold;
  color: ${props => props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor };
  text-align: left;
  min-width: 100%;
  margin: 0 0 1.5rem 0;
  padding: 0;
`

export const Button = styled(DefaultButton)`
  flex: 0;
  max-height: 3rem;
  min-height: 3rem;
  min-width: 100%;
  max-width: 100%;
`

export const Paragraph = styled.div`
  color: ${props => props.theme.main && props.theme.main.general && props.theme.main.general.blue01Color };
  min-width: 100%;
  max-width: 100%;
  text-align: left;
  font-size: 1rem;
  margin: 0;
  padding: 0;

  &.quick-description {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  &.description {
    font-size: .8rem;
    margin-bottom: 1rem;
  }

  &.created-at {
    font-size: .8rem;
  }

  &.expires-at {
    font-size: .8rem;
    margin-bottom: 1rem;
  }

  &.highlight {
    font-size: 1.4rem;
    color: ${props => props.theme.main && props.theme.main.general && props.theme.main.general.blue06Color };
    font-weight: bold;
  }
`

export const Title = styled.div`
  display : flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;

  svg {
    width: 1.425rem;
    height: 1.425rem;
    align-self: center;
    cursor: pointer;

    g {
      stroke: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
    }

    path {
      fill: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
    }
  }
`

export const CloseButton = styled.button`
  padding: 1rem;
  background: none;
  border: 0 none;
  color: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000'};
  text-align: end;
  position: absolute;
	right: 0;
	top: 0;
	font-size: 1.5rem;
	z-index: 1;

	@media (min-width: 40rem) {
		right: -1rem;
		top: -3.5rem;
	}

  @media (max-width: 40rem) {
		display: none;
	}
`

